import { HStack, Stack } from "@chakra-ui/react";
import { ReactComponent as CheckCircle } from "../../assets/check-circle.svg";
import styles from "../confirm.css";
import SmallContainer from "../../Components/Container/SmallContainer";
import CustomButton from "../../Components/Button/CustomButton";
import { useLocation, useNavigate } from "react-router-dom";
import LargeContainer from "../../Components/Container/LargeContainer";
import SubHeading from "../../Components/Text/SubHeading";
import useLegacyIframeResizeMessage from "../../hooks/useLegacyIframeResizeMessage";

export default function BookingConfirmed() {
  useLegacyIframeResizeMessage();
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");

  const {
    selectedSlot,
    emailAddress,
    phoneNumber,
    selectedDate,
    showAmendButton,
  } = location?.state || {};

  const navigateAmend = () => {
    navigate(`/update-booking?token=${token}`, {
      state: { emailAddress, phoneNumber },
    });
  };

  const navigateExit = () => {
    navigate("/", { replace: true });
  };

  const formattedBookingDate = selectedDate
    ? selectedDate.toDateString().split(" ").slice(0, 4).join(" ")
    : "";

  return (
    <LargeContainer minH={"100vh"}>
      <SmallContainer alignItems="center" margin="50px">
        <Stack bg="white" boxShadow="lg" p="32px" rounded={5}>
          <HStack bg="white" p="32px" rounded={5}>
            <CheckCircle />
            <b className={styles.bookingConfirmed}>Booking Confirmed</b>
          </HStack>
          <SmallContainer
            alignItems="center"
            bg="white"
            boxShadow="lg"
            p="10px"
            border="1px solid #E5E5E5"
          >
            <SubHeading
              subHeadingLabel={"Date: " + formattedBookingDate}
              fontSize="10px"
            ></SubHeading>
            <SubHeading
              subHeadingLabel={"Slot: " + selectedSlot.slotTime}
              fontSize="10px"
              marginTop="10px"
            ></SubHeading>
          </SmallContainer>
          <SmallContainer margin="20px">
            {showAmendButton && (
              <CustomButton
                buttonLabel="Amend Booking"
                marginTop="20px"
                onClick={navigateAmend}
              ></CustomButton>
            )}
            <CustomButton
              buttonLabel="Exit"
              marginTop="20px"
              onClick={navigateExit}
            ></CustomButton>
          </SmallContainer>
        </Stack>
      </SmallContainer>
    </LargeContainer>
  );
}
